// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"96686557","453":"c4eaef64"}[chunkId] + ".chunk.js";
};